var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color: "#4D4D4D",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.895 4.07479C21.7163 3.25349 21.7163 1.9197 20.895 1.0984C20.0737 0.277097 18.74 0.277097 17.9186 1.0984L11 8.02361L4.07479 1.10497C3.25349 0.283667 1.9197 0.283667 1.0984 1.10497C0.277097 1.92627 0.277097 3.26006 1.0984 4.08136L8.02361 11L1.10497 17.9252C0.283667 18.7465 0.283667 20.0803 1.10497 20.9016C1.92627 21.7229 3.26006 21.7229 4.08136 20.9016L11 13.9764L17.9252 20.895C18.7465 21.7163 20.0803 21.7163 20.9016 20.895C21.7229 20.0737 21.7229 18.74 20.9016 17.9186L13.9764 11L20.895 4.07479Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMark);
export default __webpack_public_path__ + "static/media/x_mark.f1e980b0355634a8e3f4e2562e8070da.svg";
export { ForwardRef as ReactComponent };